import { configureStore } from "@reduxjs/toolkit";

import authToken from "./slice/token";
import bogusReducers from "./slice/bogus";

const store = configureStore({
  reducer: {
    ...bogusReducers,
    authToken: authToken.reducer,
  },
});

export default store;